import type { ReactElement } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface LoadingStatProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingStat = ({
  className,
  baseContainerClasses,
}: LoadingStatProps): ReactElement => (
  <div className={classNames(baseContainerClasses, "gap-2", className)}>
    <div className="bg-tertiary h-4 w-1/2 animate-pulse rounded-full" />
    <div className="bg-tertiary h-8 w-1/3 animate-pulse rounded-full" />
  </div>
);
